import { ProgramTermsArray } from '@/queries/academic_terms/schema'
import {
  GlobalProgramsResponseProps,
  ProgramYearsProps,
} from '@/queries/program/schemas'
import { isAfter } from 'date-fns'
import { toZonedTime } from 'date-fns-tz'

export function hasProgramStartDatePassed(
  programStartDate: string,
  programTimezone: string | null | undefined
) {
  // Use program timezone or fallback to UTC
  const timezone = programTimezone || 'UTC'

  // Get current time in the program's timezone
  const nowInProgramTimezone = toZonedTime(new Date(), timezone)

  // Parse the program start date in the program's timezone
  const startDateInProgramTimezone = toZonedTime(
    new Date(programStartDate),
    timezone
  )

  // Check if current time is after the program start date
  return isAfter(nowInProgramTimezone, startDateInProgramTimezone)
}

export function getAcademicTermsByTermType(
  programAcademicTerms: ProgramTermsArray,
  programSettings: ProgramYearsProps
) {
  const filteredTerms = programAcademicTerms.filter((term) => {
    return (
      term.academic_term.academic_term_type_id ===
      programSettings.academic_term_type_id
    )
  })

  return filteredTerms.sort(
    (a, b) => a.academic_term.term_number - b.academic_term.term_number
  )
}
export const dateToYYYYMMDD = (date: string) => {
  return date.split(' ')[0]
}

/**
 * Retrieves the selected program year from the program details data.
 *
 * Note: We're not using Redux store here because:
 * - Redux state doesn't stay synchronized with server data after mutations
 * - Program state is duplicated in multiple places in Redux, making consistency difficult
 * - TanStack Query provides a single source of truth that stays in sync with the server
 */
export function getSelectedProgramYear(
  programDetails: GlobalProgramsResponseProps,
  selectedProgramYearId: number
) {
  const mergedProgramYears = programDetails
    .map((program) => {
      return program.programs
    })
    .flat()

  const selectedYear = mergedProgramYears.find(
    (program) => program.id === selectedProgramYearId
  )
  return selectedYear
}
